import { render, staticRenderFns } from "./defra-activities.vue?vue&type=template&id=236b9b30&scoped=true"
import script from "./defra-activities.vue?vue&type=script&lang=js"
export * from "./defra-activities.vue?vue&type=script&lang=js"
import style0 from "./defra-activities.vue?vue&type=style&index=0&id=236b9b30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236b9b30",
  null
  
)

export default component.exports